export const userIsVhiCustomer = citizen => {
    const { clientCode, parentClientCode } = citizen.latestUserCampaignActivity || {};
    return [clientCode, parentClientCode].includes("18_VHI");
};

export const userIsBupaCustomer = citizen => {
    const { clientCode, parentClientCode } = citizen.latestUserCampaignActivity || {};
    return [clientCode, parentClientCode].includes("19_BUPA");
};
